import { normalizedUuidSchema } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { useParams } from 'react-router';
import { SitePageShell } from '@/shared/ui';
import { PortfolioDetail } from '@/widgets/portfolio-detail';
import { SiteFooter } from '@/widgets/site-footer';
import { SiteHeader } from '@/widgets/site-header';

export const PortfolioDetailPage = (): ReactElement => {
  const { id = '' } = useParams();
  const parsed = normalizedUuidSchema.safeParse(id);
  return (
    <SitePageShell header={<SiteHeader />} footer={<SiteFooter />}>
      <PortfolioDetail id={parsed.success ? parsed.data : ''} validId={parsed.success} />
    </SitePageShell>
  );
};
